import { AppBar, Box, Button, IconButton, Chip, Toolbar, useMediaQuery, Drawer, Grid, useTheme } from '@mui/material';
import headerStyles from './Header.styles';
import { useLocation } from 'react-router-dom';
import finvu from '../../assets/finvu.png';
import CloseIcon from "@mui/icons-material/Close";
import AuthApis from '../../hepler/authApis.service';
import DialogBox from '../Dialog Box/Dialog Box';
import CancelConsent from '../Accounts/CancelConsent';
import { useState } from 'react';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import StepperBar from './Stepper';
import SelectLang from './SelectLang';
import { withTranslation } from '../../hoc/withTranslation';

function Header(props) {
	const theme = useTheme();
	const { t } = props;
	const isMobile = useMediaQuery(theme.breakpoints.down('md'));
	
	// Check for dark theme
	const isDark = props.customDetails?.darkTheme === true || theme.palette.mode === 'dark';
	const authApis = new AuthApis();
	const [openDialog, setOpenDialog] = useState(false);
	const [openMultiLang, setOpenMultiLang] = useState(false);
	const history = useHistory();
	const handleCancel = () => {
		setOpenDialog(false);
		history.push({
			pathname: `/consent-status`,
			state: {
				status: 'Consent denied',
				statusCode: authApis.handleCancelTermination("cancel"),
			},
		});
	}
	const location = useLocation();
	const currentPath = location.pathname;
	const shouldShowIcon = location.pathname.includes('home') || location.pathname.includes('accounts');
	const isLoginPage = /^(\/$|\/login\/?([^/]+)?$)/.test(location.pathname);
	const isConsentStatusPage = /^\/consent-status\/?$/.test(location.pathname);
	const handleClose = (event, reason) => {
		setOpenDialog(false);
	};
	const closeMultiLang = () => {
		setOpenMultiLang(false)
	}
	const showStepper =
		/^\/$/.test(currentPath) ||                             
		/^\/home\/?$/.test(currentPath) ||                     
		/^\/login\/?([^/]+)?$/.test(currentPath) ||             
		/^\/accounts\/[^/]+\/?([^/]+)?$/.test(currentPath) ||  
		/^\/payment-consent\/?$/.test(currentPath) ||          
		/^\/NoAccountFound\/[^/]+$/.test(currentPath);  
	return (
		<Box sx={{
			...headerStyles.container,
			backgroundColor: isDark ? '#161616' : 'transparent',
			color: isDark ? '#FFFFFF' : '#000000'
		}}>
			<AppBar sx={{
				...headerStyles.appBar, 
				background: isDark ? '#161616' : theme.palette.background.default,
				color: isDark ? '#FFFFFF' : '#000000'
			}}>
				<Toolbar sx={{
					...headerStyles.p0,
					backgroundColor: isDark ? '#161616' : 'transparent'
				}}>
					<Box sx={headerStyles.imageBox}>
						{props.customDetails?.logo ? (
							<Box sx={headerStyles.logoContainer}>
								<img
									src={props.customDetails?.logo}
									alt="logo"
									style={{...headerStyles.logo,
										maxHeight:isMobile ? "2rem" : "2.5rem",
										paddingRight: shouldShowIcon ? "1rem" : "0",
									}}
								/>
							</Box>
						) : null}
						<Grid
						sx={{
							...headerStyles.logoContainer,
							alignItems: "center",
							display: "flex",
							maxWidth: "100%",
							marginRight: "0px"
						}}>
						{props?.customDetails?.subLogo && (
							<Box
							sx={{
								...headerStyles.logoContainer,
								justifyContent: "end",
								maxWidth: "100%",
								marginRight: "0px"
							}}
							>
								<img
									src={props.customDetails.subLogo}
									alt="logo"
									style={{
									...headerStyles.subLogo,
									paddingRight: shouldShowIcon ? "2rem" : "0",
									maxHeight:	isMobile ? "2rem" : "2.5rem"
									}}
								/>
							</Box>
							)}
						{global.sdkOptions?.allowSelectLang === 'true' &&
							<Chip label="Aa/अ" variant="outlined" sx={{marginRight: '0.5rem'}} onClick={()=> setOpenMultiLang(true)}/>
                        }
							{shouldShowIcon && (
								<IconButton
									onClick={() => setOpenDialog(true)}
									disableRipple
									sx={{
										...headerStyles.cancelIcon,
										color: isDark ? '#FFFFFF' : theme.palette.primary.main,
										backgroundColor: isDark ? '#2D2D2D' : theme.palette.primary.light,
									}}
								>
									<CloseIcon sx={{
										...headerStyles.cancelIconFont,
										color: isDark ? '#FFFFFF' : 'inherit'
									}} />
								</IconButton>
							)}
						</Grid>
					</Box>
				</Toolbar>
			</AppBar>
			{showStepper && !isLoginPage && !isConsentStatusPage && (
				<StepperBar customDetails={props.customDetails} />
			)}
			<DialogBox
				open={openDialog}
				handleClose={handleClose}
				title={t('header.dialog.cancelConsent.title')}
				subTitle={t('header.dialog.cancelConsent.subtitle')}
				boxPadding="1.5rem"
				subTitleMaxWidth="85%"
			>
				<CancelConsent
					handleCancel={handleClose}
					{...props}
					handleDeny={handleCancel}
				/>
			</DialogBox>
			{!isMobile ? 
			<DialogBox
			   open={openMultiLang}
			   handleClose={closeMultiLang} 
			   sx={{border: '2px solid black', display: { xs: 'none', sm: 'none', md: 'none' }}}
			   boxPadding='0'
			>
			   <SelectLang
			     handleCancel={closeMultiLang}
				 customDetails={props.customDetails}
			   />
			</DialogBox>
			:
			<Drawer
			   open={openMultiLang}
			   anchor="bottom"
			   onClose={closeMultiLang}
			   sx={{display: { xs: 'flex', sm: 'flex', md: 'none' }}}
			>
				<SelectLang
				 handleCancel={closeMultiLang}
				 customDetails={props.customDetails}
				/>
			</Drawer>
			}
		</Box>
	);
}

export default withTranslation(Header);
